import { CompanyFeed } from '@/components/CompanyFeed';
import PageAnchor from '@/components/PageAnchor';
import { LATEST_NEWS_AND_UPDATES_ANCHOR } from '@/constants/anchors';
import { SubSubSectionHeader } from '@/pages/CompanyReport/components/Overview/components/SubSubSectionHeader';
import { MoreUpdates } from './components/MoreUpdates';

import { Container, StyledCompanyFeed } from './styled';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';

interface Props {
  lookupValue: string;
}
export function RecentUpdates(props: Props) {
  const t = useOverviewTranslation();
  return (
    <>
      <PageAnchor
        type="sub-section-title"
        id={LATEST_NEWS_AND_UPDATES_ANCHOR}
      />
      <SubSubSectionHeader>
        {t('pricePerformance.recentNews.title')}
      </SubSubSectionHeader>
      <StyledCompanyFeed
        templateColumnsMd="repeat(2, 1fr)"
        templateRows="repeat(3, max-content)"
        alignItems="start"
      >
        <CompanyFeed lookup={props.lookupValue} showLimit={6} isCompanyReport />
      </StyledCompanyFeed>
      <Container>
        <MoreUpdates
          buttonTitle={t('pricePerformance.recentNews.seeMore')}
          menuTitle={t('pricePerformance.recentNews.recentUpdates')}
          lookup={props.lookupValue}
        />
      </Container>
    </>
  );
}
